import React from 'react'
import { H2, Paragraph, Separator } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'

export default function HiddenTreeMessage() {
  const [t] = useTranslation()

  return (
    <>
      <Separator />
      <H2 size="H5" centered>
        {t('group-management.latest-changes.heading')}
      </H2>
      <Separator size="xxs" />
      <Paragraph size="sm" centered>
        {t('group-management.changes-to-tree.description')}
      </Paragraph>
      <Separator />
    </>
  )
}
